import { useCallback } from 'react';

import { axiosClient } from '@/services/BaseApi.service';

import type { AcronisTopic } from '../AcronisTopics.types';

export type AcronisTopicsRequest = {
  base_url: string;
  client_id: string;
  client_secret: string;
};

export type AcronisTopicsResponse = {
  topics: AcronisTopic[];
};

export function useAcronisTopicsApi() {
  const getTopics = useCallback(
    async (request: AcronisTopicsRequest): Promise<AcronisTopicsResponse> => {
      try {
        const response = await axiosClient.post<
          { topics: AcronisTopic[] } | AcronisTopic[]
        >('/lima_sources/acronis/topics', request);

        const data = response.data;
        const topics = Array.isArray(data) ? data : data.topics || [];

        return {
          topics
        };
      } catch (error) {
        throw new Error(
          `Failed to fetch Acronis topics: ${error instanceof Error ? error.message : String(error)}`
        );
      }
    },
    []
  );

  return {
    getTopics
  };
}

export default useAcronisTopicsApi;
